import React from 'react';

import TextParser from '../textParser';

import { TEXT_TYPES } from './constants';

const Text = React.memo(({ uiData, className }) => {
  const { type, value, variable } = uiData ?? {};

  switch (type) {
    case TEXT_TYPES.MARKDOWN:
      return (
        <TextParser value={value} className={className} variables={variable} />
      );
    case TEXT_TYPES.TEXT:
    default:
      return <div className={className}>{value}</div>;
  }
});

Text.displayName = 'Text';

export default Text;
